module.exports = __webpack_public_path__ + "media/ScreenFuerWeb_699hoch_1.5641cbc6.mp4";